//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React from "react";

// custom pages
import Logo from "assets/img/logo.png";
import { signupStyles } from "./styles";

// ant-design
import { Row, Col } from "antd";

// ant-design icons
import GlobalOutlined from "@ant-design/icons/GlobalOutlined";
import FacebookFilled from "@ant-design/icons/FacebookFilled";
import InstagramOutlined from "@ant-design/icons/InstagramOutlined";
import TwitterOutlined from "@ant-design/icons/TwitterOutlined";
import LinkedinFilled from "@ant-design/icons/LinkedinFilled";
import YoutubeFilled from "@ant-design/icons/YoutubeFilled";

export default function SignupParent(props) {
  const classes = signupStyles();

  return (
    <Row className={classes.row}>
      <Col
        xs={{ span: 24 }}
        sm={{ span: 15 }}
        lg={{ span: 15 }}
        className={classes.colRight}
      >
        <div className={classes.imgDiv}>
          <img src={Logo} className={classes.img} alt="logo" />
        </div>
        <div className={classes.contentDiv}>
          <div className={classes.contentHeadDiv}>Don't have an account?</div>
          <div
            className={classes.descriptionDiv}
          >
            Register to access all the features fo our service.
          </div>
          <div
            className={classes.descriptionDiv}
          >
            Manage the loyalty programme in one place.
          </div>
        </div>
        <div className={classes.iconDiv}>
          <GlobalOutlined className={classes.icon} />
          <FacebookFilled className={classes.icon} />
          <InstagramOutlined className={classes.icon} />
          <TwitterOutlined className={classes.icon} />
          <LinkedinFilled className={classes.icon} />
          <YoutubeFilled className={classes.icon} />
        </div>
      </Col>
      <Col
        xs={{ span: 24 }}
        sm={{ span: 9 }}
        lg={{ span: 9 }}
        className={classes.colLeft}
      >
        {props.children}
      </Col>
    </Row>
  );
}
